import React from 'react';
import { Sidebar } from './components/Sidebar';
import { Header } from './components/Header';
import { ExperimentDashboard } from './components/ExperimentDashboard';
export function App() {
  return <div className="flex min-h-screen bg-[#f5f7fa] font-sans" data-id="element-0">
      {/* Fixed Sidebar */}
      <div className="fixed inset-y-0 left-0 z-20" data-id="element-1">
        <Sidebar data-id="element-2" />
      </div>

      {/* Main Content Area - offset by sidebar width */}
      <div className="flex-1 ml-64 flex flex-col min-h-screen" data-id="element-3">
        <Header data-id="element-4" />
        <main className="flex-1 overflow-auto" data-id="element-5">
          <ExperimentDashboard data-id="element-6" />
        </main>
      </div>
    </div>;
}